import React, {Fragment, useEffect, useState} from "react";
import {isUndefined} from 'lodash';
import {Grid, Pagination} from 'semantic-ui-react'

import {Banner, Header as MyHeader, Maps} from "../../components";
import {Places} from './Places';
import {Filters} from './Filters';
import {getCategory} from "../../redux/actions";
import {useIntl} from "react-intl";

let city_id = JSON.parse(localStorage.getItem('_CITY'))['value'];

export const Categories = ({from, location, history, match}) => {

    const hash = location.hash.substr(1);
    const params = match.params;

    const values = new URLSearchParams(hash);
    const page = values.get('page') || 1;
    const q = values.get('q') || '';

    let category_id = params.id;
    let __subcategory = {};
    let subsub = 0;

    if (values.get('category')) {
        category_id = values.get('category');

        __subcategory = {
            id: values.get('category'),
            child_count: values.get('childs')
        };
    }

    if (values.get('subcategory')) {
        category_id = values.get('subcategory');
        subsub = category_id;
    }

    if(from === 'search'){
        city_id = undefined;
    }

    const [find, setFind] = useState({category_id, city_id, page, limit: 6, subsub, q});
    const [pagination, setPagination] = useState({current_page: 1, page_count: 1});
    const [markers, setMarkers] = useState([]);
    const [category, setCategory] = useState(location.state);
    const [subcategory, setSubcategory] = useState(__subcategory);
    const [details, setDetails] = useState({});

    const events = useIntl().formatMessage({id: 'Eventos'});
    const search = useIntl().formatMessage({id: 'Pesquisar'});

    const newFind = (data = {}) => {

        if (data.page) {

            values.set('page', data.page);
        }

        if (data.subcategory) {

            values.set('subcategory', data.category_id);
        }

        if (data.category) {
            values.set('category', data.category_id);
            values.set('childs', data.child_count);
            values.delete('subcategory');
        }

        if (data.q) {
            values.set('q', data.q);
        }

        window.location.hash = values.toString();

        setFind({...data, city_id, limit: 6});
    };

    useEffect(() => {

        const fetchData = async () => {

            if (!isUndefined(location.state)) {

                setCategory(location.state);

                newFind();

                return;
            }

            try {

                // get category
                const result = await getCategory(params.id);

                // set places
                setCategory(result.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }
        };

        if (from === 'places') {

            // noinspection JSIgnoredPromiseFromCall
            fetchData();

        } else if (from === 'events') {

            setCategory({name: events});
        } else {

            setCategory({name: search});
        }

    }, [params.id, events, from, search, location.search]);

    useEffect(() => {

        const fetchData = async () => {

            if (isUndefined(find.category_id)) {

                return;
            }

            try {

                // get category
                const result = await getCategory(find.category_id);

                // set places
                await setDetails(result.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [find]);

    return (
        <Fragment>
            <MyHeader/>
            {
                category && <Banner city_id={city_id} category_id={category.id} top={1} align={'center no-pb'}/>
            }
            <Grid>
                <Grid.Row>
                    <Grid.Column mobile={16} tablet={16} computer={7}>
                        <Grid className={'no-padding-rows'}>
                            <Grid.Row>
                                <Grid.Column style={{backgroundColor: '#FFF'}}>
                                    <Filters
                                        from={from}
                                        search={find}
                                        setSearch={newFind}
                                        setSubcategory={setSubcategory}
                                        subcategory={subcategory}
                                        category={{...category}}
                                        history={history}
                                        pagination={pagination}
                                        location={location}
                                        city_id={city_id}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                {
                                    <Places
                                        from={from}
                                        category={!isUndefined(details.id) ? details : category}
                                        params={params}
                                        search={find}
                                        setMarkers={setMarkers}
                                        setPagination={setPagination}
                                        location={location}
                                    />
                                }
                            </Grid.Row>
                            <Grid.Row style={{justifyContent: 'center'}}>
                                {
                                    pagination.page_count > 1 && <Pagination
                                        boundaryRange={0}
                                        defaultActivePage={pagination.current_page}
                                        ellipsisItem={null}
                                        firstItem={null}
                                        lastItem={null}
                                        siblingRange={2}
                                        totalPages={pagination.page_count}
                                        onPageChange={(e, {activePage}) => newFind({
                                            category_id: find.category_id,
                                            page: activePage
                                        })}
                                    />
                                }

                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                    <Grid.Column
                        width={9}
                        style={{
                            minHeight: 512,
                            height: 512,
                            paddingTop: '1rem',
                            paddingLeft: 0
                        }}
                        only={'large screen'}
                    >
                        <Maps
                            markers={markers}
                            category={!isUndefined(details.id) ? details : category}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            {
                category && <Banner city_id={city_id} category_id={category.id} bottom={1} align={'center'}/>
            }
        </Fragment>
    );
};

